import { __assign, __awaiter, __generator, __read } from "tslib";
import * as IDBKeyVal from 'idb-keyval';
import { MAX_IDB_STORAGE_LENGTH, STORAGE_PREFIX, defaultSessionStore } from './constants';
import { STORAGE_FAILURE } from './messages';
import { RecordingStatus, } from './typings/session-replay';
var SessionReplaySessionIDBStore = /** @class */ (function () {
    function SessionReplaySessionIDBStore(_a) {
        var apiKey = _a.apiKey, loggerProvider = _a.loggerProvider;
        var _this = this;
        this.storageKey = '';
        this.getAllSessionDataFromStore = function () { return __awaiter(_this, void 0, void 0, function () {
            var storedReplaySessionContexts, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IDBKeyVal.get(this.storageKey)];
                    case 1:
                        storedReplaySessionContexts = _a.sent();
                        return [2 /*return*/, storedReplaySessionContexts];
                    case 2:
                        e_1 = _a.sent();
                        this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, undefined];
                }
            });
        }); };
        this.storeEventsForSession = function (events, sequenceId, sessionId) { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IDBKeyVal.update(this.storageKey, function (sessionMap) {
                                var _a, _b;
                                if (sessionMap === void 0) { sessionMap = {}; }
                                var session = sessionMap[sessionId] || __assign({}, defaultSessionStore);
                                session.currentSequenceId = sequenceId;
                                var currentSequence = (session.sessionSequences && session.sessionSequences[sequenceId]) || {};
                                currentSequence.events = events;
                                currentSequence.status = RecordingStatus.RECORDING;
                                return __assign(__assign({}, sessionMap), (_a = {}, _a[sessionId] = __assign(__assign({}, session), { sessionSequences: __assign(__assign({}, session.sessionSequences), (_b = {}, _b[sequenceId] = currentSequence, _b)) }), _a));
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.cleanUpSessionEventsStore = function (sessionId, sequenceId) { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IDBKeyVal.update(this.storageKey, function (sessionMap) {
                                if (sessionMap === void 0) { sessionMap = {}; }
                                var session = sessionMap[sessionId];
                                var sequenceToUpdate = (session === null || session === void 0 ? void 0 : session.sessionSequences) && session.sessionSequences[sequenceId];
                                if (!sequenceToUpdate) {
                                    return sessionMap;
                                }
                                sequenceToUpdate.events = [];
                                sequenceToUpdate.status = RecordingStatus.SENT;
                                // Delete sent sequences for current session
                                Object.entries(session.sessionSequences).forEach(function (_a) {
                                    var _b = __read(_a, 2), storedSeqId = _b[0], sequence = _b[1];
                                    var numericStoredSeqId = parseInt(storedSeqId, 10);
                                    if (sequence.status === RecordingStatus.SENT && sequenceId !== numericStoredSeqId) {
                                        delete session.sessionSequences[numericStoredSeqId];
                                    }
                                });
                                // Delete any sessions that are older than 3 days
                                Object.keys(sessionMap).forEach(function (sessionId) {
                                    var numericSessionId = parseInt(sessionId, 10);
                                    if (Date.now() - numericSessionId >= MAX_IDB_STORAGE_LENGTH) {
                                        delete sessionMap[numericSessionId];
                                    }
                                });
                                return sessionMap;
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_3));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.loggerProvider = loggerProvider;
        this.storageKey = "".concat(STORAGE_PREFIX, "_").concat(apiKey.substring(0, 10));
    }
    return SessionReplaySessionIDBStore;
}());
export { SessionReplaySessionIDBStore };
//# sourceMappingURL=session-idb-store.js.map